import axios from 'axios'

export default {
    async create(model) {
        return await axios.post(`role`, model)
    },
    async fetchById(id) {
        return await axios.get(`role/${id}`)
    },
    async fetch(query, page) {
        return await axios.get(`role?q=${query}&page=${page}`)
    },

    async fetchAll() {
        return await axios.get(`role/all`)
    },
    async update(id, model) {
        return await axios.put(`role/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`role/${id}`)
    },
}
